export default {
  JLatexServer: { domain: 'https://api.ebag-test.readboy.com/latex/' },
  'accurate-admin-web': {
    'single-api-domain': 'https://prodapi.hhyunyue.com/console',
  },
  'area-teaching-quality-web': { domain: 'https://ebag-test.readboy.com/area-teaching-quality/' },
  'ebag-examination-web': {
    'bigdata-report-web':
      'https://www.hhyunyue.com/report/#/',
    domain: 'https://www.hhyunyue.com/exam/',
    'examination-answer-sheet-domain': 'https://www.hhyunyue.com/answercard',
    'new-examination-answer-sheet-domain': 'https://www.hhyunyue.com/answercard',
    'learning-analysis': 'http://ebag.io.dreamdev.cn/web/examination-system/learning-analysis/#/',
    'unified-examination-display-board-web':
      'https://ebag-test.readboy.com/unified-examination-display-board',
    'word-guide-paper-web-domain': 'https://www.hhyunyue.com/exam-word-web/',
  },
  'ebag-html2pdf-api': { domain: 'https://prodapi.hhyunyue.com/html2pdf' },
  'examination-answer-sheet-api': {
    QiniuDomain: 'https://res.hhyunyue.com/',
    domain: 'https://prodapi.hhyunyue.com/answercard',
  },
  'examination-single': {
    'accurate-admin-web': 'https://www.hhyunyue.com/console/',
    'exam-api-domain': 'https://prodapi.hhyunyue.com/exam',
    'exampay-api-domain': 'https://prodapi.hhyunyue.com/exampay',
    'login-domain': 'https://prodapi.hhyunyue.com/login',
    PDF_REPORT_WEB: 'https://ebag-test.readboy.com/examination-report',
  },
  'examination-web': {
    'service-web': 'https://ebag-test.readboy.com/examination-synthetical-service/#/',
  },
  'three-years-question': { THREE_YEARS_QUESTION: 'https://test.snztw.com' },
  zsdata: { domainResource: 'https://contres.readboy.com' },
};
